import { render, staticRenderFns } from "./ScreenProtectorTypeList.vue?vue&type=template&id=0831593c"
import script from "./ScreenProtectorTypeList.vue?vue&type=script&lang=js"
export * from "./ScreenProtectorTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports